<template lang="pug">
span
  v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="360" min-width="320" max-width="320" nudge-bottom="8" z-index="11")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(v-if="selectedMethods.length > 0" outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
        .text-xs.font-semibold {{ $t('payment_method') }}
        .px-1.neutral400--text | 
        .text-xs.primary--text.font-medium {{ getSelectedMethods() }}
        v-icon.ml-1(size=16) $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(size=13) $yzi-plus-circle
        .text-xs.text-none.font-semibold {{ $t('payment_method') }}
    
    .white
      .font-semibold.text-sm.px-4.pt-4.pb-2 {{ $t('filter_by') }} {{ $t('payment_method').toLowerCase() }}
      div.px-4.py-3
        div
          y-checkbox(v-model="pmSelfPay" @change="tickSelfPay")
            template(#label)
              .text-sm.neutral700--text Self pay
          div.ml-4
            template(v-for="selfpay in selfpayList")
              y-checkbox.mt-1(v-model="methods.selfpay" :value="selfpay.id" @change="checkSelfPay" :key="selfpay.id")
                template(#label)
                  .text-sm.neutral700--text {{ selfpay.name }}
        div.mt-3
          y-checkbox(v-model="pmPanel" @change="tickPanel")
            template(#label)
              .text-sm.neutral700--text Panel
          div.ml-4
            template(v-for="panel in panels")
              y-checkbox.mt-1(v-model="methods.panels" :value="panel.id" @change="checkPanel" :key="panel.id")
                template(#label)
                  .text-sm.neutral700--text {{ panel.name }}

    .bottom-0.sticky.z-1.white
      .d-flex.align-center.px-4.py-3.border-t
        .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="selectedMethods.length > 0" @click="clear") {{ $t('clear') }}
        v-spacer
        v-btn.button-sm(color="primary" depressed :disabled="disabledButton" @click="apply") {{ $t('apply') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'FilterPaymentMethod',
  props: ['filter', 'filterKey'],
  data: () => ({
    showMenu: false,
    isFetching: false,
    pmSelfPay: false,
    pmPanel: false,
    panels: [],
    selfpayList: [],
    methods: {
      selfpay: [],
      panels: []
    },
  }),
  watch: {
    filter: {
      handler () {
        if (!this.filter.key) { this.clearData() }
      } 
    },
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    disabledButton () {
      return !this.selectedMethods.length > 0
    },
    selectedMethods () {
      return this.methods.selfpay.concat(this.methods.panels)
    }
  },
  mounted () {
    this.fetchPaymentMethods()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchPaymentMethods () {
      this.isFetching = true
      let params = {
       page_size: -1,
       company: this.company.id,
       enabled: true
      }
      this.$axios.get(`/payment_methods`, { params })
        .then(resp => {
          if (resp.data && resp.data.results) {
            let payment_method = resp.data.results
            this.selfpayList = payment_method.filter(f => f.channel === 'self-pay')
            this.panels = payment_method.filter(f => f.channel === 'panel')
            this.$emit('fetched', resp.data)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    clear () {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData () {
      this.methods = {
        selfpay: [],
        panels: []
      }
      this.pmSelfPay = false
      this.pmPanel = false
      this.checkSelfPay()
      this.checkPanel()
    },
    apply () {
      this.showMenu = false
      const filterKey = this.filterKey ?? 'ref_ids'
      const filter = { key: filterKey, value: this.selectedMethods.join() }
      this.$emit('update:filter', filter)
    },
    checkSelfPay () {
      if (this.methods.selfpay.length > 0) {
        this.pmSelfPay = true
      } else {
        this.pmSelfPay = false
      }
    },
    tickSelfPay () {
      if (this.pmSelfPay) {
        this.methods.selfpay = this.selfpayList.map(m => m.id)
      } else {
        this.methods.selfpay = []
      }
    },
    checkPanel () {
      if (this.methods.panels.length > 0) {
        this.pmPanel = true
      } else {
        this.pmPanel = false
      }
    },
    tickPanel () {
      if (this.pmPanel) {
        this.methods.panels = this.panels.map(m => m.id)
      } else {
        this.methods.panels = []
      }
    },
    getSelectedMethods () {
      const count = this.selectedMethods.length
      return `${count} selected`
    },
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
</style>